<template>
    <div class="locale-switcher">
        <ejs-dropdownlist :enabled="false" id='localeDropdownList' :dataSource='locales' :index='localeIndex' :fields='fields' :change.native="onChange" :placeholder='dropdownPlaceholder'></ejs-dropdownlist>
    </div>
</template>

<script>
    import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
    import { getSupportedLocales, supportedLocalesInclude } from "@/util/i18n/supported-locales";
    import Vue from 'vue';
    import i18n, { getActiveLocale } from "@/i18n";
    import nav from '@/containers/_nav';
    import store from '@/store';

    Vue.use(DropDownListPlugin);

    localiseSidebarNav(getActiveLocale());

    export default {
        data: () => ({
            fields: { text: 'name', value: 'code' }
        }),
        methods: {
            onChange(event) {
                localiseSidebarNav(event.value);
            },
        },
        computed: {
            dropdownPlaceholder() {
                return i18n.t("Select a language");
            },
            locales() {
                return getSupportedLocales();
            },
            activeLocale() {
                return localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || "en";
            },
            localeIndex() {
                return this.locales.map(l => l.code).indexOf(this.activeLocale);
            }
        }
    }

    function localiseSidebarNav(locale) {
        if (locale === null || locale === 'null' || locale.trim() === '' || !supportedLocalesInclude(locale)) {
            locale = getActiveLocale();
        }
        i18n.locale = locale;
        localStorage.setItem('locale', locale);
        
        let navProps = Object.assign([], nav);

        for (let i = 0; i < navProps.length; i++) {
            for (let j = 0; j < navProps[i]._children.length; j++) {
                navProps[i]._children[j].name = i18n.t(nav[i]._children[j].lookupName);
                if (nav[i]._children[j].items) {
                    for (let k = 0; k < navProps[i]._children[j].items.length; k++) {
                        navProps[i]._children[j].items[k].name = i18n.t(nav[i]._children[j].items[k].lookupName);
                    }
                }
            }
        }

        store.commit("setNavBarItems", navProps);
    }
</script>